// ANCHOR Base
import { Block } from 'baseui/block';
import { HeadingLarge, LabelXSmall } from 'baseui/typography';

// ANCHOR Models
import { useFormQuestionData } from '@lyon/scoped-models/form/FormQuestionData';
import { useFormDataShuffleQuestion } from '@lyon/scoped-models/form/FormData';
import { useFormQuestionActiveValue } from '@lyon/scoped-models/form/FormQuestionActive';

// ANCHOR GraphQL
import {
  Form_Question_Types_Enum as QuestionTypes,
} from '@lyon/graphql/types';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { Loader } from '@lyon/components/utils/Loader';
import { UpdateFormQuestionForm } from '@lyon/scoped-models/form/update/UpdateFormQuestionForm';
import { LyonUpdateFormContentMultipleChoice } from './LyonUpdateFormContentMultipleChoice';
import { LyonUpdateFormContentSaveButton } from './LyonUpdateFormContentSaveButton';
import { LyonUpdateFormContentShort } from './LyonUpdateFormContentShort';
import { LyonUpdateFormContentEssay } from './LyonUpdateFormContentEssay';
import { LyonUpdateFormContentAttachment } from './LyonUpdateFormContentAttachment';
import { LyonUpdateFormContentSpacer } from './LyonUpdateFormContentSpacer';
import { LyonUpdateFormContentCheckbox } from './LyonUpdateFormContentCheckbox';

// ANCHOR Styles
import { HEADER, BUTTON_CONTAINER, TYPE } from './styles';

// ANCHOR Constants
import { QUESTION_TYPES } from './constants';

export const LyonUpdateFormContentQuestionBody = constant(() => {
  const question = useFormQuestionData();
  const activeQuestionId = useFormQuestionActiveValue();
  const shuffleQuestion = useFormDataShuffleQuestion();

  if (!question || !activeQuestionId) {
    return <Loader />;
  }

  const { position, name, type } = question;

  const NUMBER = (position >= 0 && position < 10) ? `0${position}` : position;
  const LABEL = `${shuffleQuestion ? '' : `${NUMBER}: `}${name}`;

  return (
    <UpdateFormQuestionForm.Provider initialData={question}>
      <Block overrides={HEADER}>
        <Block>
          <HeadingLarge marginTop={0} marginBottom={0}>
            {LABEL}
          </HeadingLarge>
          <LabelXSmall overrides={TYPE}>
            {`Question Type: ${QUESTION_TYPES[type]}`}
          </LabelXSmall>
        </Block>
        <Block overrides={BUTTON_CONTAINER}>
          <LyonUpdateFormContentSaveButton />
        </Block>
      </Block>
      {type === QuestionTypes.MultipleChoice && <LyonUpdateFormContentMultipleChoice />}
      {type === QuestionTypes.CheckboxAnswer && <LyonUpdateFormContentCheckbox />}
      {type === QuestionTypes.ShortAnswer && <LyonUpdateFormContentShort />}
      {type === QuestionTypes.Essay && <LyonUpdateFormContentEssay />}
      {type === QuestionTypes.Attachment && <LyonUpdateFormContentAttachment />}
      {type === QuestionTypes.Spacer && <LyonUpdateFormContentSpacer />}
    </UpdateFormQuestionForm.Provider>
  );
});
